export const sportsTypeOptions = [
  {
    value: 'adventure_running',
    label: 'Adventure Running'
  },
  {
    value: 'air_sports',
    label: 'Air Sports'
  },
  {
    value: 'football',
    label: 'Football'
  },
  {
    value: 'cycling',
    label: 'Cycling'
  },
  {
    value: 'gym',
    label: 'Gym'
  },
  {
    value: 'tennis',
    label: 'Tennis'
  },
  {
    value: 'walking',
    label: 'Walking'
  },
  {
    value: 'equestrian_sports',
    label: 'Equestrian Sports'
  },
  {
    value: 'heritage_sports',
    label: 'Heritage Sports'
  },
  {
    value: 'community_sports',
    label: 'Community Sports'
  },
  {
    value: 'district_field',
    label: 'District Field'
  }
]

export const stakeholderTypeOptions = [
  {
    value: 'players',
    label: 'Players'
  },
  {
    value: 'attendees',
    label: 'Attendees'
  },
  {
    value: 'volunteers',
    label: 'Volunteers'
  },
  {
    value: 'employees',
    label: 'Employees'
  },
  {
    value: 'community_players',
    label: 'Community Players'
  },
  {
    value: 'community_attendees',
    label: 'Community Attendees'
  },
  {
    value: 'community_coaches',
    label: 'Community Coaches'
  },
  {
    value: 'community_volunteers',
    label: 'Community Volunteers'
  },
  {
    value: 'temporary_coaches',
    label: 'Temporary Coaches'
  },
  {
    value: 'permanent_coaches',
    label: 'Permanent Coaches'
  },
  {
    value: 'community_temporary_coaches',
    label: 'Community Temporary Coaches'
  },
  {
    value: 'community_permanent_coaches',
    label: 'Community Permanent Coaches'
  },
  {
    value: 'permanent_employees',
    label: 'Permanent Employees'
  },
  {
    value: 'temporary_employees',
    label: 'Temporary Employees'
  }
]

// stakeholder details section
export const STAKEHOLDERS_LIST = 'categorical_data'
export const STAKEHOLDER_TYPE = 'stakeholder_type'
export const SPORTS_TYPE = 'sports_type'
export const STAKEHOLDER_COUNT = 'stakeholder_count'
export const AVERAGE_ANNUAL_COST = 'average_annual_cost'

// gender
export const GENDER_PERCENTAGE = 'gender_percentage'
export const genderFields = {
  female: 'female',
  male: 'male',
  prefer_not_to_say: 'prefer_not_to_say',
  other: 'other',
  unknown: 'unknown'
}
// Keep legacy exports for backwards compatibility
export const MALE_PERCENTAGE = 'male'
export const FEMALE_PERCENTAGE = 'female'
export const UNKNOWN_GENDER_PERCENTAGE = 'unknown'

// ethnicity
export const ETHNICITY_PERCENTAGE = 'ethnicity_percentage'
export const ethnicityFields = {
  white: 'white',
  asian: 'asian',
  black: 'black',
  mixed: 'mixed',
  unknown: 'unknown',
  local: 'local',
  non_local: 'non_local',
  international: 'international'
}

// age distribution
export const AGE_PERCENTAGE = 'age_percentage'
export const ageFields = {
  under_12: 'under_12',
  age_12_18: 'age_12_18',
  age_19_24: 'age_19_24',
  age_25_60: 'age_25_60',
  above_60: 'above_60',
  unknown: 'unknown'
}

export const ageFieldLabels = {
  [ageFields.under_12]: 'Children',
  [ageFields.age_12_18]: 'Teen',
  [ageFields.age_19_24]: 'Youth',
  [ageFields.age_25_60]: 'Adult',
  [ageFields.above_60]: 'Old',
  [ageFields.unknown]: 'Unknown'
}

// activity levels
export const ACTIVITY_LEVELS = 'activity_levels'
export const activityLevelFields = {
  inactive: 'inactive',
  less_active: 'less_active',
  fairly_active: 'fairly_active',
  active: 'active',
  unknown: 'unknown'
}

// disability
export const DISABILITY_PERCENTAGE = 'disability_percentage'
export const disabilityFields = {
  no: 'no',
  yes: 'yes',
  unknown: 'unknown'
}

// index of multiple deprivation
export const IMD_PERCENTAGE = 'imd_percentage'
export const imdFields = {
  imd_1: 'imd_1',
  imd_2: 'imd_2',
  imd_3: 'imd_3',
  imd_4: 'imd_4',
  imd_5: 'imd_5',
  imd_6: 'imd_6',
  imd_7: 'imd_7',
  imd_8: 'imd_8',
  imd_9: 'imd_9',
  imd_10: 'imd_10',
  unknown: 'unknown'
}

// wellbeing ratings (before/after)
export const AVERAGE_LIFE_SATISFACTION_RATING_BEFORE = 'average_life_satisfaction_rating_before'
export const AVERAGE_LIFE_SATISFACTION_RATING_AFTER = 'average_life_satisfaction_rating_after'
export const AVERAGE_PURPOSE_OF_LIFE_RATING_BEFORE = 'average_purpose_of_life_rating_before'
export const AVERAGE_PURPOSE_OF_LIFE_RATING_AFTER = 'average_purpose_of_life_rating_after'
export const AVERAGE_HAPPINESS_RATING_BEFORE = 'average_happiness_rating_before'
export const AVERAGE_HAPPINESS_RATING_AFTER = 'average_happiness_rating_after'
export const AVERAGE_DECREASED_ANXIETY_RATING_BEFORE = 'average_decreased_anxiety_rating_before'
export const AVERAGE_DECREASED_ANXIETY_RATING_AFTER = 'average_decreased_anxiety_rating_after'

export const initialStakeholder = {
  [STAKEHOLDER_TYPE]: '',
  [SPORTS_TYPE]: '',
  [STAKEHOLDER_COUNT]: 0,
  [AVERAGE_ANNUAL_COST]: '',
  [GENDER_PERCENTAGE]: {
    ...Object.fromEntries(Object.values(genderFields).map(field => [field, 0]))
  },
  [ETHNICITY_PERCENTAGE]: {
    ...Object.fromEntries(Object.values(ethnicityFields).map(field => [field, 0]))
  },
  [AGE_PERCENTAGE]: {
    ...Object.fromEntries(
      Object.values(ageFields).map(field => [
        field,
        {
          total: 0,
          ...Object.fromEntries(Object.values(activityLevelFields).map(activityField => [activityField, 0]))
        }
      ])
    )
  },
  [DISABILITY_PERCENTAGE]: {
    ...Object.fromEntries(Object.values(disabilityFields).map(field => [field, 0]))
  },
  [IMD_PERCENTAGE]: {
    ...Object.fromEntries(Object.values(imdFields).map(field => [field, 0]))
  },
  [AVERAGE_LIFE_SATISFACTION_RATING_BEFORE]: 0,
  [AVERAGE_LIFE_SATISFACTION_RATING_AFTER]: 0,
  [AVERAGE_PURPOSE_OF_LIFE_RATING_BEFORE]: 0,
  [AVERAGE_PURPOSE_OF_LIFE_RATING_AFTER]: 0,
  [AVERAGE_HAPPINESS_RATING_BEFORE]: 0,
  [AVERAGE_HAPPINESS_RATING_AFTER]: 0,
  [AVERAGE_DECREASED_ANXIETY_RATING_BEFORE]: 0,
  [AVERAGE_DECREASED_ANXIETY_RATING_AFTER]: 0
}
